import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PerformanceConstantsService {

  constructor() { }

  public static PDNavigation: any = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Performance Dashboard',
        routeURL: '/pd/dashboard/',
        isClickable: true
      },
      {
        routeName: 'Contractor Statistics',
        routeURL: '/pd/statistic/',
        isClickable: true

      },
      {
        routeName: 'Contractor Statistics Overview',
        routeURL: '/pd/overview',
        isClickable: true
      }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Performance Dashboard',
        routeURL: '/pd/dashboard/',
        isClickable: true
      },
      {
        routeName: 'Contractor Statistics',
        routeURL: '/pd/statistic/',
        isClickable: true
      },
      {
        routeName: 'Contractor Statistics Overview',
        routeURL: '/pd/overview/',
        isClickable: true
      }
    ],
    ReportRoutes: []
  };

    // URL constant
    public static PerformanceURL = {
      GetLeaderPersonalData: 'api/pd/get/getLeaderPersonalData',
      GetLeaderProcessData: 'api/pd/get/getLeaderProcessData',
      GetActionTrackerData: 'api/pd/get/getActionTrackerData',
      GetContractDetailsData: 'api/pd/get/getContractDetails',
      SaveContractorStat: 'api/pd/post/saveContractorStatistics',
      GetSafetyObservationData: 'api/pd/get/getSafetyObservationData',
      GetEnergyConsumptionData: 'api/pd/get/getEnergyConsumptionData',
      GetStatisticStatus:'api/pd/get/getStatisticStatus',
      GetStatisticRequests : 'api/pd/get/getStatisticRequests',
      ExportToExcel: 'api/pd/get/exportToExcelStatistics',
      GetStatisticRequestByStatisticId: 'api/pd/get/getStatisticByStatisticId',
      SaveContraStatApproval: 'api/pd/post/savePDApprovals',
      GetObservationTypeData: 'api/pd/get/getObservationTypeData',
      GetKPIData: 'api/pd/get/getKPIData',
      GetActionPriorityData: 'api/pd/get/getActionPriorityData',
      GetWasteGenerationData: 'api/pd/get/getWasteGenerationData',
      GetIncidentHighPotentialData: 'api/pd/get/getIncidentHighPotentialData',
      GetIncidentTypeData: 'api/pd/get/getIncidentTypeData',
      GetObservationByObserverData: 'api/pd/get/getObservationByObserverData',
      GetObservationActionData:'api/pd/get/getObservationActionData',
      GetManHourCalculationData:'api/pd/get/getManHourCalculationData',
      GetHeadCountData:'api/pd/get/getHeadCountData',
      GetKPIDetails: 'api/pd/get/getKPIDetails',
      GetKPITargetsByYear:'api/pd/get/getKPITargets',
      SaveOrUpdateKPITargets:'api/pd/get/SaveOrUpdateKPITargets',
      DownloadZip: 'api/pd/get/downloadzip',
      downloadPDF: 'api/pd/get/downloadpdf',
      GetPDSelectedDetails: 'api/pd/get/getPDSelectedDetails',
      GetInspectionTypeData: 'api/pd/get/getInspectionTypeData',
      GetObservationCategoryData: 'api/pd/get/getObservationCategoryData',
      GetIncidentCategoryData: 'api/pd/get/getIncidentCategoryData',
      GetTrainingStatusData: 'api/pd/get/getTrainingStatusData',
      GetTrainingComplianceData: 'api/pd/get/getTrainingComplianceData',
      GetTrainingComplianceSummaryData: 'api/pd/get/getTrainingComplianceSummaryData',
      GetIncidentRegisterData: 'api/pd/get/getIncidentRegisterData',
      GetEnergyWasteConsumptionData: 'api/pd/get/getEnergyWasteConsumptionData',
      GetEnergyWasteConsumptionUnitWiseData: 'api/pd/get/getEnergyWasteConsumptionUnitWiseData',
      GetPOBRosterData: 'api/pd/get/getPOBRosterData',
      GetPOBRosterMonthwiseData: 'api/pd/get/getPOBRosterMonthwiseData',
    };
}

export enum Months {
        Jan = 1,
        Feb,
        Mar,
        Apr,
        May,
        Jun,
        Jul,
        Aug,
        Sep,
        Oct,
        Nov,
        Dec
}

export enum StatisticStatus {
  Approved = 1,
  Rejected,
  PendingForApproval,
  Cancelled,
  Deleted,
  Draft
}
